export const updateNewUser = 'updateNewUser';
export const updateIsAddUserClicked = 'updateIsAddUserClicked';
export const updateUsers = "updateUsers";
export const updateIsEditUserClicked = "updateIsEditUserClicked";
export const updateUsersDataTable = "updateUsersDataTable";
export const updateIsViewUserClicked = "updateIsViewUserClicked";

export const updateNewRole = 'updateNewRole';
export const updateIsAddRoleClicked = 'updateIsAddRoleClicked';
export const updateRoles = "updateRoles";
export const updateIsEditRoleClicked = "updateIsEditRoleClicked";
export const updateRolesDataTable = "updateRolesDataTable";
export const updateIsViewRoleClicked = "updateIsViewRoleClicked";


export const updateNewPermission = 'updateNewPermission';
export const updateIsAddPermissionClicked = 'updateIsAddPermissionClicked';
export const updatePermissions = "updatePermissions";
export const updateIsEditPermissionClicked = "updateIsEditPermissionClicked";
export const updatePermissionsDataTable = "updatePermissionsDataTable";
export const updateIsViewPermissionClicked = "updateIsViewPermissionClicked";


export const updateIsAddNotificationClicked = 'updateIsAddNotificationClicked';
export const updateNotifications = "updateNotifications";
export const updateNewNotifications = "updateNewNotifications";
export const updateIsEditNotificationClicked = "updateIsEditNotificationClicked";